import { GlDisclosureDropdownItem, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf, __ } from '~/locale';
import { capitalizeFirstCharacter } from '~/lib/utils/text_utility';
import delayedJobMixin from '~/ci/mixins/delayed_job_mixin';
import JobActionButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/common/private/job_action_button.vue?vue3';
import JobNameComponent from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/common/private/job_name_component.vue?vue3';
export default {
    name: 'JobDropdownItem',
    components: {
        JobActionButton,
        JobNameComponent,
        GlDisclosureDropdownItem
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        delayedJobMixin
    ],
    props: {
        job: {
            type: Object,
            required: true
        }
    },
    emits: [
        'job-action-executed'
    ],
    computed: {
        hasJobAction () {
            return Boolean(this.status?.action?.id && this.status?.action?.icon);
        },
        item () {
            return {
                text: this.job.name,
                href: this.status?.detailsPath || this.status?.deploymentDetailsPath || ''
            };
        },
        status () {
            return this.job.detailedStatus || this.job.status;
        },
        isFailed () {
            return this.status?.group === 'failed';
        },
        tooltipText () {
            const statusTooltip = capitalizeFirstCharacter(this.status?.tooltip);
            if (this.isDelayedJob) {
                return sprintf(statusTooltip, {
                    remainingTime: this.remainingTime
                });
            }
            return statusTooltip;
        },
        hasUnauthorizedManualAction () {
            return !this.status?.action && this.status?.group === 'manual';
        },
        unauthorizedManualAction () {
            /*
        The action object is not available when the user cannot run the action.
        So we can show the correct icon, extract the action name from the label instead:
        "manual play action (not allowed)" or "manual stop action (not allowed)"
      */ return {
                title: __('You are not authorized to run this manual job'),
                icon: this.status?.label?.split(' ')[1],
                confirmationMessage: null
            };
        }
    }
};
